import React from 'react';
import Draggable from 'react-draggable';
import styled from '@emotion/styled'
import {Portal} from "./Portal";

const RootContainer = styled.div`
    width: 0;
    height: 0;
    position: relative;
`
type WindowDivParams = {
    width: string
    height: string
  }

const InnerWindow = styled.div<WindowDivParams>`
    padding: 0px;
    ${props => {
        return `
        height: ${props.height};
        width: ${props.width};
        `
    }}
    border-radius: 0px 0px 4px 4px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: white;

    animation-fill-mode: forwards;
    animation-name: start-animation;
    animation-duration: 300ms;

    @keyframes start-animation
    {
        0% {
            opacity: 0;
            transform: scale3d(0.3, 0.3, 0.3);
        }
        
        50% {
            opacity: 1;
        }

        100% {
            opacity: 1;
        }
    }
`
const BlockingBackgrond = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width:  100%;
    position: absolute; 
    left: 0;
    top: 0;
    background-color: rgba(255,255,255, 0.7);
    z-index: 1000;
`

type WithChildren<T = {}> = 
T & { 
    children?: React.ReactNode,
    show: boolean,
    width?: string,
    height?: string
 };

export function Window({ children, show, width = '50rem', height = '30rem' }: WithChildren) {
    return (
       <RootContainer>
        {show &&(
        <Portal>
        <BlockingBackgrond>
            <Draggable handle=".handle">
                <InnerWindow width={width} height={height}>
                    {children}
                </InnerWindow>
            </Draggable>
        </BlockingBackgrond>
        </Portal>
        )}
        </RootContainer>
    );
  }
  